// A target revision's workflow definitions. `default` is read through its blob, whose route resolves a blob id
// whatever organization it names, so the page's own may stand in. docs/specs/2026-09-25-workflow-reference.md
export function listTargetDefinitions(api, orgId, blob, revision) {
  const revisionId = "default" === revision
    ? api.blobsIdGet(orgId, blob).then(response => response.data.blob.default_revision_id)
    : Promise.resolve(revision);
  return revisionId
    .then(id => api.revisionsIdDataQueryPost(id, { command: "list_definitions", category: "workflow" }))
    .then(response => response.data.definitions || []);
}
